import type { AxisLeaf } from "utils/tableModel"
import { BuilderSource } from "features/Dashboard/types/dashboardDocument"

const lastSegment = (path: string): string => path.split("//").pop() ?? path

/**
 * Maps a clicked header leaf to a codebook condition. The tile's variables
 * for that axis supply the codebook path; the leaf's id (its codebook
 * labels, which a display rename leaves alone) supplies the category.
 * Totals are not conditions. A leaf on the statistic axis still names its
 * category (every leaf there carries `stat`), so it resolves too.
 */
export const resolveLeafToCondition = (args: {
  leaf: AxisLeaf
  axis: "down" | "across"
  source: BuilderSource
  transposed?: boolean
}): { variable: string; category: string } | null => {
  const { leaf } = args
  if (leaf.isTotal || leaf.id === "") return null
  const rowsAxis = args.transposed ? "across" : "down"
  const variables =
    args.axis === rowsAxis ? args.source.rows : args.source.columns
  if (variables.length === 0) return null
  if (variables.length === 1) {
    return { variable: variables[0], category: leaf.id }
  }
  // A banner leaf id is "<variable label>//<category>".
  const cut = leaf.id.indexOf("//")
  const head = cut < 0 ? leaf.id : leaf.id.slice(0, cut)
  const rest = cut < 0 ? "" : leaf.id.slice(cut + 2)
  const variable = variables.find((v) => lastSegment(v) === head)
  if (!variable || rest === "") {
    console.warn(
      "[dashboard] cross-filter click ignored: no variable for leaf",
      leaf.id
    )
    return null
  }
  return { variable, category: rest }
}
